import { supportedWidths } from './constants/supportedWidths.js';
let baseSupportedWidths;
let allSupportedWidths;
// All dimensions in the supportedDimensions object are also supported 2x the size for Retina screens
const calculateAllSupportedWidthsIncludingRetina = () => {
    return supportedWidths
        .reduce((acc, width) => {
        if (!acc.includes(width)) {
            acc.push(width);
        }
        const retinaWidth = width * 2;
        if (!acc.includes(retinaWidth)) {
            acc.push(retinaWidth);
        }
        return acc;
    }, [])
        .sort((a, b) => a - b);
};
const getBaseSupportedWidths = () => {
    if (baseSupportedWidths) {
        return baseSupportedWidths;
    }
    const supportedWidthsClone = [...supportedWidths];
    baseSupportedWidths = supportedWidthsClone.sort((a, b) => a - b);
    return baseSupportedWidths;
};
const getAllSupportedWidths = () => {
    if (allSupportedWidths) {
        return allSupportedWidths;
    }
    allSupportedWidths = calculateAllSupportedWidthsIncludingRetina();
    return allSupportedWidths;
};
const getClosestSupportedWidth = (supportedDimensions, requested) => {
    for (const supported of supportedDimensions) {
        if (supported >= requested) {
            return supported;
        }
    }
    return supportedDimensions[supportedDimensions.length - 1];
};
// for the initial width we only search through the supported widths without the retina sizes so that we can guarantee the image has a 2x version as well
export const getInitialImageByWidth = (requestedWidth) => getClosestSupportedWidth(getBaseSupportedWidths(), requestedWidth);
export const getClosestAvailableWidthByPixelRatio = (srcWidth, pixelRatio) => {
    const width = srcWidth * pixelRatio;
    const allSupportedWidths = getAllSupportedWidths();
    return getClosestSupportedWidth(allSupportedWidths, width);
};
//# sourceMappingURL=imageDimension.js.map